"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.processing.done': 'Completado',
    'avatar.processing.is_processing': 'Procesando',
};
